import type { ChatOrderProduct } from './ChatOrderProductCandidatesModal';
import type { ProductDeliveryState } from './hooks/useChatOrderSelection';

interface DeliveryFeeSectionProps {
  product: ChatOrderProduct;
  isProductSelected: boolean;
  deliveryState: ProductDeliveryState;
  formatPrice: (amount: number) => string;
  onToggle: (productId: string) => void;
  onSelectOption: (productId: string, index: number) => void;
}

const DeliveryFeeSection = ({
  product,
  isProductSelected,
  deliveryState,
  formatPrice,
  onToggle,
  onSelectOption,
}: DeliveryFeeSectionProps) => {
  const { includeDeliveryFee, selectedDeliveryFeeOptionIndex } = deliveryState;

  return (
    <div className="delivery-fee-section">
      <div className="delivery-fee-check">
        <input
          type="checkbox"
          id={`delivery-${product._id}`}
          checked={isProductSelected && includeDeliveryFee}
          onChange={() => onToggle(product._id)}
          disabled={!isProductSelected}
        />
        <label htmlFor={`delivery-${product._id}`}>
          {product.deliveryFeeOptions.length === 1
            ? `배송비 ${formatPrice(product.deliveryFeeOptions[0].fee.amount)} 추가`
            : '배송비 추가'}
        </label>
      </div>
      {isProductSelected && includeDeliveryFee && product.deliveryFeeOptions.length > 1 && (
        <div className="delivery-fee-options">
          {product.deliveryFeeOptions.map((option, index) => (
            <div
              key={option.name}
              className="delivery-fee-option"
              role="radio"
              aria-checked={selectedDeliveryFeeOptionIndex === index}
              tabIndex={0}
              onClick={() => onSelectOption(product._id, index)}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSelectOption(product._id, index); } }}
            >
              <div className={`delivery-fee-radio ${selectedDeliveryFeeOptionIndex === index ? 'selected' : ''}`} />
              <span>{option.name} {formatPrice(option.fee.amount)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DeliveryFeeSection;
